import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { Card, Input, Button, Form, Select, message, Tabs } from "antd";
import storageUtils from "../../utils/storageUtils";
import { getDateYYYYMMDD } from "../../utils/dateUtil";
import { req_add_pim_flexible_log_staff } from "../../api";

const Item = Form.Item;
class FlexibleLogStaffAddModal extends Component {
  // 基礎通用參數 //////////////////////////////////////////////
  static propTypes = {
    data: PropTypes.object.isRequired,
  };

  state = {
    lock:false,
    workStatusList: [
      { label: "停班", value: "PASS" },
      { label: "上班", value: "WORK" },
    ],
    reasonList: [
      { label: "停班停課", value: "停班停課" },
      { label: "補休日", value: "補休日" },
      { label: "休息日", value: "休息日" },
      { label: "工作日", value: "工作日" },
      { label: "補班日", value: "補班日" },
    ],
    selectedWorkStatus: "WORK",
    selectedReason: "工作日",
    inputStaffCode: "",
    inputDate: getDateYYYYMMDD(new Date()),
    inputBunchIn: "1300",
    inputBunchOut: "2100",
    inputRestStart: "1730",
    inputRestEnd: "1800",
    inputRecordDescription: "",
    inputGroupDepartment: "",
    inputGroupTable: "",
    inputAccordingDescription: "",
    item: {
      ClockType: "FLEXIBLE",
      StaffCode: "",
      FlexibleDate: getDateYYYYMMDD(new Date()),
      FlexibleClockIn: "1300",
      FlexibleClockOut: "2100",
      FlexibleReason: "工作日",
      FlexibleStatus: "WORK",
      ApplyStatus: "ALLAGREE",
      RestStartTime: "1730",
      RestEndTime: "1800",
      RecordDescription: "",
      GroupDepartment: "",
      GroupTable: "",
      AccordingDescription: "",
      RecordCreatorCode: this.props.user.userCode,
    },
  };

  api_modify_item = async (item) => {
    const result = await req_add_pim_flexible_log_staff(
      item,
      storageUtils.getUser().token
    );
    if (result.status === "success") {
      message.success(result.message);
    } else {
      message.error(result.message);
    }
  };

  // 操作互動處理 //////////////////////////////////////////////
  handleWorkStatusChange = (value) => {
    //console.log(value);
    this.setState({ selectedWorkStatus: value });
  };

  handleReasonChange = (value) => {
    //console.log(value);
    this.setState({ selectedReason: value });
  };

  onFinish = (values) => {
    const { item, selectedWorkStatus, selectedReason } = this.state;
    //console.log("Success:", values);

    item.StaffCode = values.inputStaffCode;
    item.FlexibleDate = values.inputDate;
    item.FlexibleClockIn = values.inputBunchIn;
    item.FlexibleClockOut = values.inputBunchOut;
    item.RestStartTime = values.inputRestStart;
    item.RestEndTime = values.inputRestEnd;
    item.FlexibleReason = selectedReason;
    item.FlexibleStatus = selectedWorkStatus;
    item.RecordDescription = values.inputRecordDescription;
    item.GroupDepartment = values.inputGroupDepartment;
    item.GroupTable = values.inputGroupTable;
    item.AccordingDescription = values.inputAccordingDescription;

    //console.log(item);
    this.api_modify_item(item);
  };

  render() {
    const {
      inputStaffCode,
      inputDate,
      inputBunchIn,
      inputBunchOut,
      inputRecordDescription,
      inputRestStart,
      inputRestEnd,
      inputAccordingDescription,
      inputGroupDepartment,
      inputGroupTable,
      selectedReason,
      selectedWorkStatus,
      workStatusList,
      reasonList,
    } = this.state;

    return (
      <Card>
        <Form onFinish={this.onFinish}>
          <Tabs defaultActiveKey="1">
            <Tabs.TabPane tab="基本資料" key="1">
              <>
                {" "}
                <Item
                  label="日期分類"
                  rules={[
                    {
                      required: true,
                      whitespace: true,
                      message: "必須填寫內容",
                    },
                  ]}
                >
                  <Select
                    defaultValue={selectedReason}
                    onChange={this.handleReasonChange}
                    style={{
                      width: "100%",
                    }}
                    options={reasonList}
                  />
                </Item>
                <Item
                  label="作息狀態"
                  rules={[
                    {
                      required: true,
                      whitespace: true,
                      message: "必須填寫內容",
                    },
                  ]}
                >
                  <Select
                    defaultValue={selectedWorkStatus}
                    onChange={this.handleWorkStatusChange}
                    style={{
                      width: "100%",
                    }}
                    options={workStatusList}
                  />
                </Item>
                <Item
                  label="作息日期"
                  name="inputDate"
                  initialValue={inputDate}
                  rules={[
                    {
                      required: true,
                      whitespace: true,
                      message: "必須填寫內容",
                    },
                  ]}
                >
                  <Input placeholder="日期格式: 20250101" />
                </Item>
                <Item
                  label="職工職號"
                  name="inputStaffCode"
                  initialValue={inputStaffCode}
                  rules={[
                    {
                      required: true,
                      whitespace: true,
                      message: "必須填寫內容",
                    },
                  ]}
                >
                  <Input placeholder="輸入職工職號" />
                </Item>
                <Item
                  label="作息起始時間"
                  name="inputBunchIn"
                  initialValue={inputBunchIn}
                  rules={[
                    {
                      required: true,
                      whitespace: true,
                      message: "必須填寫內容",
                    },
                  ]}
                >
                  <Input placeholder="時間格式: 0800" />
                </Item>
                <Item
                  label="作息結束時間"
                  name="inputBunchOut"
                  initialValue={inputBunchOut}
                  rules={[
                    {
                      required: true,
                      whitespace: true,
                      message: "必須填寫內容",
                    },
                  ]}
                >
                  <Input placeholder="時間格式: 1700" />
                </Item>
                <Item
                  label="作息說明"
                  name="inputRecordDescription"
                  initialValue={inputRecordDescription}
                >
                  <Input placeholder="" />
                </Item>
              </>
            </Tabs.TabPane>
            <Tabs.TabPane tab="其他資料" key="2">
              <>
                {" "}
                <Item
                  label="休息起始時間"
                  name="inputRestStart"
                  initialValue={inputRestStart}
                  rules={[
                    {
                      required: true,
                      whitespace: true,
                      message: "必須填寫內容",
                    },
                  ]}
                >
                  <Input placeholder="時間格式: 1730" />
                </Item>
                <Item
                  label="休息結束時間"
                  name="inputRestEnd"
                  initialValue={inputRestEnd}
                  rules={[
                    {
                      required: true,
                      whitespace: true,
                      message: "必須填寫內容",
                    },
                  ]}
                >
                  <Input placeholder="時間格式: 1800" />
                </Item>
                <Item
                  label="依據說明"
                  name="inputAccordingDescription"
                  initialValue={inputAccordingDescription}
                >
                  <Input placeholder="" />
                </Item>
                <Item
                  label="輪班部門"
                  name="inputGroupDepartment"
                  initialValue={inputGroupDepartment}
                >
                  <Input placeholder="" />
                </Item>
                <Item
                  label="輪班表名稱"
                  name="inputGroupTable"
                  initialValue={inputGroupTable}
                >
                  <Input placeholder="" />
                </Item>
                <Item>
                  <Button
                    type="primary"
                    htmlType="submit"
                    className="wave"
                    block
                  >
                    {"送出"}
                  </Button>
                </Item>
              </>
            </Tabs.TabPane>
          </Tabs>
        </Form>
      </Card>
    );
  }
}

export default connect(
  (state) => ({ user: state.user }),
  {}
)(FlexibleLogStaffAddModal);
